import { proxyCustomElement, HTMLElement, h } from '@stencil/core/internal/client';
import { W as WppIcon } from './WppIcon.js';

const wppIconCss = ":host{display:-ms-inline-flexbox;display:inline-flex;color:var(--wpp-prop-icon-color)}";

const WppIconRecycle$1 = /*@__PURE__*/ proxyCustomElement(class WppIconRecycle extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.__attachShadow();
    this.size = 'm';
    this.width = undefined;
    this.height = undefined;
    this.color = 'var(--wpp-icon-color)';
  }
  render() {
    return (h(WppIcon, { name: "wpp-icon-recycle", width: this.width, height: this.height, size: this.size, color: this.color }, h("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M8.06178 2.60165C8.92424 1.12855 11.0545 1.13402 11.9097 2.61068L11.9097 2.61078L13.7956 5.86808L14.001 5.10722C14.1089 4.70732 14.5206 4.47064 14.9205 4.57858C15.3204 4.68652 15.5571 5.09821 15.4492 5.49811L14.774 7.99955C14.6667 8.3969 14.2593 8.63359 13.861 8.52993L11.34 7.87388C10.9392 7.76956 10.6988 7.36003 10.8031 6.95917C10.9074 6.55831 11.3169 6.31791 11.7178 6.42223L12.5012 6.62611L10.6117 3.36245C10.6116 3.36242 10.6116 3.36239 10.6116 3.36235C10.3325 2.88054 9.6377 2.87885 9.35627 3.35948C9.35626 3.35949 9.35625 3.35951 9.35624 3.35952L6.9174 7.52575C6.70815 7.88322 6.24873 8.00338 5.89126 7.79412C5.53379 7.58486 5.41364 7.12544 5.62289 6.76797L8.06175 2.6017L8.06178 2.60165ZM4.99836 8.37739C5.39842 8.27023 5.80962 8.50764 5.91685 8.90769L6.59242 11.4283C6.69965 11.8284 6.46225 12.2396 6.06215 12.3469C5.66206 12.4541 5.25079 12.2167 5.14356 11.8166L4.92808 11.0126L3.10554 14.0753C3.10553 14.0753 3.10552 14.0753 3.10551 14.0754C2.81747 14.5596 3.1664 15.173 3.72966 15.173H8.51412C8.92833 15.173 9.26412 15.5088 9.26412 15.923C9.26412 16.3372 8.92833 16.673 8.51412 16.673H3.72966C2.00274 16.673 0.933548 14.7923 1.81646 13.3083L1.81649 13.3083L3.60449 10.3036L2.8659 10.5015C2.46579 10.6087 2.05456 10.3712 1.94738 9.97109C1.8402 9.57099 2.07767 9.15975 2.47778 9.05258L4.99836 8.37739ZM14.8312 9.06242C15.1887 8.85316 15.6481 8.97331 15.8574 9.33078L18.1937 13.3219C18.1938 13.322 18.1938 13.322 18.1938 13.3221C19.0629 14.8063 17.9923 16.673 16.2727 16.673H12.5388L13.1039 17.2381C13.3968 17.531 13.3968 18.0058 13.1039 18.2987C12.811 18.5916 12.3361 18.5916 12.0432 18.2987L10.1979 16.4533C9.90496 16.1605 9.90496 15.6856 10.1979 15.3927L12.0432 13.5473C12.3361 13.2544 12.811 13.2544 13.1039 13.5473C13.3968 13.8402 13.3968 14.3151 13.1039 14.608L12.5388 15.173H16.2727C16.8338 15.173 17.1828 14.564 16.8994 14.08L16.8993 14.0799L14.5629 10.0886C14.3536 9.7311 14.4738 9.27167 14.8312 9.06242Z", fill: "currentColor" })));
  }
  static get registryIs() { return "wpp-icon-recycle-v2-21-0"; }
  static get style() { return wppIconCss; }
}, [1, "wpp-icon-recycle", "wpp-icon-recycle-v2-21-0", {
    "size": [1],
    "width": [2],
    "height": [2],
    "color": [1]
  }]);
function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["wpp-icon-recycle-v2-21-0"];
  components.forEach(tagName => { switch (tagName) {
    case "wpp-icon-recycle-v2-21-0":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, WppIconRecycle$1);
      }
      break;
  } });
}

const WppIconRecycle = WppIconRecycle$1;
const defineCustomElement = defineCustomElement$1;

export { WppIconRecycle, defineCustomElement };
